// extracted by mini-css-extract-plugin
module.exports = {"delete-button":"DeleteButton_delete-button__3lUll","delete-button__icon":"DeleteButton_delete-button__icon__3FvdU"};